import React, { useContext } from 'react';
import logo from '../assets/logo.svg';
import { useNavigate, useLocation } from 'react-router-dom';
import { IoCartOutline } from "react-icons/io5";
import { CartContext } from '../context/CartContext';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasItems, uniqueItemsCount } = useContext(CartContext);
  const restaurant = location.state;

  const isMenuPage = location.pathname.includes('/menu-items/');

  return (
    <div className="flex items-center px-4 justify-between shadow-md border-b-gray-400 fixed top-0 w-full z-50 bg-white h-16 md:h-20">
      <div className="w-full max-w-[90%] flex justify-between items-center mx-auto">
        {isMenuPage && restaurant ? (
          <h1 className="text-xl font-semibold text-[#171725]">{restaurant.name}</h1>
        ) : (
          <img src={logo} alt="Logo" className="w-10 h-auto md:w-12" />
        )}
        <button onClick={() => navigate('/cart')} className="p-2 relative">
          <IoCartOutline className="w-8 h-8 md:w-10 md:h-10" />
          {hasItems && (
            <div className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center">
              <span className="text-white text-xs font-bold">{uniqueItemsCount}</span>
            </div>
          )}
        </button>
      </div>
    </div>
  );
};

export default Header;
